export const siteConfig = {
  name: "Coval",
  description: "Evaluation for AI",
  links: {
    linkedin: "https://www.linkedin.com/in/bnhop/",
  },
}
